import { Component, OnInit, ElementRef, Renderer2, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivitiesService } from "./activities.service";
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { I18nService } from '@app/shared/i18n/i18n.service';
import { CommonService } from "@app/shared/common/common.service";
import { ActivitiesRefreshService } from '@app/shared/activities-refresh.service';
import moment from 'moment';
import { Subscription } from 'rxjs';

declare var $: any;
@Component({
  selector: 'sa-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
  providers: [ActivitiesService],
})
export class ActivitiesComponent implements OnInit, OnDestroy {
  count: number;
  lastUpdate: any;
  active: boolean;
  activities: any;
  currentActivity: any;
  loading: boolean;
  ajaxNotificationsHeight = '75px';
  imgPath = environment.NETGATE_URL + "/ngtFiles/netgate05/ngtSysImages/profileImage/";
  notifyLength = 0;
  public currentLanguage: any;
  apiErrorMessageOptions: {};
  ajaxDropdownHeight = '156px';
  lanId;
  langChangeSubscription: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private activitiesService: ActivitiesService,
    private router: Router,
    private i18nService: I18nService,
    private commonService: CommonService,
    private cd: ChangeDetectorRef,
    private activitiesRefreshService: ActivitiesRefreshService
  ) {

    this.active = false;
    this.loading = false;
    this.activities = [];
    this.count = 0;
    this.lastUpdate = new Date();
    let self = this;
    setTimeout(() => {
      $("body").off('click', '#notifyId  li').on('click', '#notifyId  li', function () {
        if (!$(this).hasClass("read")) {
          $(this).addClass('read');
          let id = $(this).attr('id');
          self.checkedNotification(id);
        }
      });
    }, 2000);
    this.currentLanguage = this.i18nService.currentLanguage;
    this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj => this.onLangChange(langObj));
  }
  onLangChange(langObj) {
    this.lanId = this.commonService.getCurrentLanguageCode();
    moment.locale(this.lanId);
  }
  supplierMap: { [key: string]: string; } = {};
  userMap: { [key: string]: string; } = {};
  onlyUnread: boolean = false;
  isMarkingAllRead: boolean = false;


  onToggleUnread(checked: boolean) {
    this.onlyUnread = checked;
    this.getNotificationsList();
  }

  markAllAsRead() {
    if (this.isMarkingAllRead || this.count === 0) {
      return;
    }

    this.isMarkingAllRead = true;

    // Optimistically update local notification items
    if (this.currentActivity && this.currentActivity.data) {
      this.currentActivity.data.forEach((item: any) => {
        if (item && item.viewed === '0') {
          item.viewed = '1';
          item.status = 'read';
        }
      });
    }
    this.count = 0;
    this.cd.detectChanges();

    let fdata = new FormData();
    fdata.append('userId', localStorage.getEncryptedItem('loginId'));
    fdata.append('companyUserId', localStorage.getEncryptedItem('companyUserId'));
    fdata.append('companyId', localStorage.getEncryptedItem('companyId'));
    fdata.append('instanceId', localStorage.getEncryptedItem('instanceId'));
    fdata.append('loggedInTime', localStorage.getEncryptedItem('loggedInTime'));
    fdata.append('lastRequestTime', localStorage.getEncryptedItem('lastRequestTime'));
    fdata.append('language', this.commonService.getCurrentLanguageCode());

    const encrData = this.buildEncryptedFormData(fdata);

    this.activitiesService.markAllApplicationEventsAsReadDirect(encrData).subscribe(
      (res: any) => {
        this.isMarkingAllRead = false;
        const isSuccess = res && (res.SUCCESS || res.success || res.status);
        if (isSuccess) {
          if (res.RESPONSETIME) {
            localStorage.setEncryptedItem('lastRequestTime', res.RESPONSETIME);
          }
          this.getNotificationsList();
        } else {
          $('#apiErrorMessageActivitiesPopup').dialog("open");
          this.getNotificationsList();
        }
        this.cd.detectChanges();
      },
      () => {
        this.isMarkingAllRead = false;
        $('#apiErrorMessageActivitiesPopup').dialog("open");
        this.getNotificationsList();
        this.cd.detectChanges();
      }
    );
  }

  private serviceRefreshSub: Subscription;

  ngOnInit() {
    this.initApiErrorMessagePopup();
    this.getSuppliersList();
    this.activitiesRefreshService.refreshActivities$.subscribe(() => {
      this.getSuppliersList();
    });
    this.serviceRefreshSub = this.activitiesService.refreshActivities$.subscribe(() => {
      this.count = Math.max(0, (this.count || 0) - 1);
      this.getNotificationsList();
    });
  }

  private buildEncryptedFormData(data: FormData): FormData {
    const object = this.commonService.createObject(data);
    const token = this.commonService.createToken(object);
    const encryptedToken = this.commonService.encrypt(token);
    const encrData = new FormData();
    encrData.append('encrToken', encryptedToken);
    return encrData;
  }

  getSuppliersList() {
    let supplierData = new FormData();
    supplierData.append("companyId", localStorage.getEncryptedItem("companyId"));
    supplierData.append("userId", localStorage.getEncryptedItem("loginId"));
    supplierData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    supplierData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    const encrData = this.buildEncryptedFormData(supplierData);
    this.activitiesService.getSuppliersList(encrData).subscribe((data: any) => {
      if (data && data.status && data.data && data.data.items) {
        let items = data.data.items;
        for (let i in items) {
          this.supplierMap[items[i].supplierId] = items[i].companyName;
        }
      }
      this.getUsersList();
    }, () => {
      this.getUsersList();
    });
  }

  getUsersList() {
    let data = new FormData();
    data.append('companyUserId', localStorage.getEncryptedItem('companyUserId'));
    data.append('instanceId', localStorage.getEncryptedItem('instanceId'));
    data.append('companyId', localStorage.getEncryptedItem('companyId'));
    data.append('userId', localStorage.getEncryptedItem('loginId'));
    data.append('loggedInTime', localStorage.getEncryptedItem('loggedInTime'));
    data.append('lastRequestTime', localStorage.getEncryptedItem('lastRequestTime'));
    data.append('language', this.commonService.getCurrentLanguageCode());
    data.append('limit', "-1");

    const encrData = this.buildEncryptedFormData(data);

    this.activitiesService.getUsers(encrData).subscribe((res: any) => {
      if (res && res.STATUS && res.DATA && res.DATA.USERS) {
        let users = res.DATA.USERS;
        for (let i in users) {
          let fullName = (users[i].PRENAME || '') + ' ' + (users[i].NAME || '');
          this.userMap[users[i].USERNUMBER] = fullName.trim();
        }
      }
      this.getNotificationsList();
    }, () => {
      this.getNotificationsList();
    });
  }
  ngAfterViewChecked() {

  }
  getNotificationsList() {
    let timePeriod = {
      "SECOND": "header_notification_SECOND", "MINUTE": "header_notification_MINUTE", "HOUR": "header_notification_HOUR", "DAY": "header_notification_DAY",
      "MONTH": "header_notification_MONTH", "YEAR": "header_notification_YEAR", "SECONDS": "header_notification_SECONDS", "MINUTES": "header_notification_MINUTES",
      "HOURS": "header_notification_HOURS", "DAYS": "header_notification_DAYS", "MONTHS": "header_notification_MONTHS", "YEARS": "header_notification_YEARS"
    };
    let profileImage;
    let fdata = new FormData();
    fdata.append('language', this.commonService.getCurrentLanguageCode());
    fdata.append('userId', localStorage.getEncryptedItem('loginId'));
    fdata.append('companyId', localStorage.getEncryptedItem('companyId'));
    fdata.append('instanceId', localStorage.getEncryptedItem('instanceId'));
    fdata.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    fdata.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    if (this.onlyUnread) {
      fdata.append('is_read', 'false');
    }
    const encrData = this.buildEncryptedFormData(fdata);
    this.activitiesService.getActivities(encrData).subscribe((data: any) => {
      const isSuccess = data.SUCCESS || data.status;
      if (!isSuccess && data.isUnauthenticated) {
        this.commonService.logout();
        return false;
      }
      if (isSuccess) {
        if (data.RESPONSETIME) {
          localStorage.setEncryptedItem("lastRequestTime", data.RESPONSETIME);
        }
        let notifyArray = [];
        let notifications = data.DATA || (data.data && data.data.notifications) || [];

        for (let i = 0; i < notifications.length; i++) {
          let item = notifications[i];
          let open;
          let duration;
          let isOne: boolean;

          if (item.profileImage) {
            profileImage = this.imgPath + item.profileImage;
          }
          else {
            profileImage = environment.NETGATE_URL + "assets/img/avatars/male.png";
          }
          let time = item.postedOn;
          let postedOn = "";
          if (time) {
            let array = time.split(' ');
            switch (array[0]) {
              case "1":
                isOne = true;
                break;
              default:
                isOne = false;
                break;
            }
            if (isOne) {
              switch (array[1]) {
                case "SECOND":
                  duration = this.i18nService.getTranslation(timePeriod['SECOND']);
                  break;
                case "MINUTE":
                  duration = this.i18nService.getTranslation(timePeriod['MINUTE']);
                  break;
                case "HOUR":
                  duration = this.i18nService.getTranslation(timePeriod['HOUR']);
                  break;
                case "DAY":
                  duration = this.i18nService.getTranslation(timePeriod['DAY']);
                  break;
                case "MONTH":
                  duration = this.i18nService.getTranslation(timePeriod['MONTH']);
                  break;
                case "YEAR":
                  duration = this.i18nService.getTranslation(timePeriod['YEAR']);
                  break;
                default:
                  duration = this.i18nService.getTranslation(timePeriod['YEAR']);
                  break;
              }
            }
            else {
              switch (array[1]) {
                case "SECOND":
                  duration = this.i18nService.getTranslation(timePeriod['SECONDS']);
                  break;
                case "MINUTE":
                  duration = this.i18nService.getTranslation(timePeriod['MINUTES']);
                  break;
                case "HOUR":
                  duration = this.i18nService.getTranslation(timePeriod['HOURS']);
                  break;
                case "DAY":
                  duration = this.i18nService.getTranslation(timePeriod['DAYS']);
                  break;
                case "MONTH":
                  duration = this.i18nService.getTranslation(timePeriod['MONTHS']);
                  break;
                case "YEAR":
                  duration = this.i18nService.getTranslation(timePeriod['YEARS']);
                  break;
                default:
                  duration = this.i18nService.getTranslation(timePeriod['YEARS']);
                  break;
              }
            }

            if (this.commonService.getCurrentLanguageCode() == 'en') {
              postedOn = array[0] + ' ' + duration + ' ' + this.i18nService.getTranslation('header_notification_ago');
            }
            else if (this.commonService.getCurrentLanguageCode() == 'de') {
              postedOn = this.i18nService.getTranslation('header_notification_ago') + ' ' + array[0] + ' ' + duration;
            }
          } else if (item.CREATED_AT) {
            postedOn = moment(item.CREATED_AT).fromNow();
          }

          const docId = item.REFERENCE_NUMBER || item.docId || '';
          const detId = item.ID || item.detId || item.TASKID || item.TASKUID || '';
          const userNum = item.USERNUMBER || item.userNumber || item.assignedByName || '';

          let metadataObj: any = {};
          if (item.METADATA) {
            if (typeof item.METADATA === 'object') {
              metadataObj = item.METADATA;
            } else if (typeof item.METADATA === 'string' && item.METADATA !== 'unknown-obj') {
              try {
                metadataObj = JSON.parse(item.METADATA);
              } catch (e) {
                metadataObj = {};
              }
            }
          }

          const rawSupplier = item.supplier || metadataObj.SUPPLIER || metadataObj.supplier || metadataObj.supplierName || item.supplierName || '';
          const supplierName = rawSupplier ? (this.supplierMap[rawSupplier] || rawSupplier) : '';
          const totalVal = (item.total !== undefined && item.total !== null && item.total !== '') ? item.total : ((metadataObj.TOTAL !== undefined && metadataObj.TOTAL !== null) ? metadataObj.TOTAL : (metadataObj.total !== undefined ? metadataObj.total : ''));
          const currencyVal = metadataObj?.CURRENCY || metadataObj?.currency || 'CHF';
          const sharedUser = metadataObj.user || '';

          let isRead = false;
          if (item.IS_READ !== undefined && item.IS_READ !== null && item.IS_READ !== '') {
            isRead = String(item.IS_READ) === '1' || item.IS_READ === true;
          } else if (item.viewed !== undefined && item.viewed !== null && item.viewed !== '') {
            isRead = String(item.viewed) === '1' || item.viewed === true;
          } else if (item.status !== undefined) {
            isRead = item.status === 'read';
          }
          const viewedStatus = isRead ? '1' : '0';

          const itemType = (item.MODULE === 'p2p' || item.type === 'PURCHASE' || item.EVENT_TYPE === 'NOTIFICATION') ? 'PURCHASE' : (item.type || item.MODULE || 'PURCHASE').toUpperCase();
          const itemTaskDate = item.CREATED_AT || item.taskDate || '';

          let customMessage = itemType == 'PURCHASE' ? this.i18nService.getTranslation(item.taskComment) : (item.taskComment || item.MESSAGE || '');
          let customSubject = itemType == 'CONTRACT' ? item.taskName : this.i18nService.getTranslation(item.taskName || item.TITLE || '');

          if (itemType === 'PURCHASE') {
            const currentLang = this.commonService.getCurrentLanguageCode();
            if (currentLang === 'de') {
              customMessage = docId ? `Die Bestellung ${docId} wurde Ihnen zur Freigabe zugewiesen.` : (item.MESSAGE || 'Warenkorb geteilt');
            } else {
              customMessage = docId ? `Order ${docId} has been assigned to you for release.` : (item.MESSAGE || 'Cart shared');
            }
            customSubject = docId
              ? (this.i18nService.getTranslation('purchase_inspector_inspector') || 'Purchase')
              : (currentLang === 'de' ? 'Warenkorb geteilt' : 'Cart shared');
          }

          let notify = {
            "message": customMessage,
            "status": viewedStatus === '0' ? "unread" : "read",
            "subject": customSubject,
            "time": postedOn,
            "title": item.assignedByName || userNum,
            "types": itemType,
            "type": "notification",
            "image": profileImage,
            "detId": detId,
            "docId": docId,
            "taskId": detId,
            "creditorId": item.creditorId,
            "assignedByName": userNum ? (this.userMap[userNum] || userNum) : (this.userMap[item.assignedByName] || item.assignedByName || ''),
            "viewed": viewedStatus,
            "versionUid": item.versionUid,
            "contactReminderId": this.i18nService.getTranslation('routeContract') + '-' + detId,
            "taskUid": item.taskUid || detId,
            "taskDate": itemTaskDate != '' ? moment(itemTaskDate).format("L") : '',
            "supplierName": supplierName,
            "total": totalVal,
            "currency": currencyVal,
            "supplierLabel": this.commonService.getCurrentLanguageCode() === 'de' ? 'Lieferant' : 'Supplier',
            "totalLabel": this.commonService.getCurrentLanguageCode() === 'de' ? 'Gesamt' : 'Total',
            "isEnglish": this.commonService.getCurrentLanguageCode() !== 'de',
            "sharedBy": sharedUser ? (this.userMap[sharedUser] || sharedUser) : ''
          };

          notifyArray.push(notify);
        }

        this.activities = [{
          "data": notifyArray,
          "name": "notifications",
          "title": "Notify"
        }];
        this.currentActivity = this.activities[0];
        const unreadCount = notifyArray.filter(n => n.viewed === '0').length;
        if (data.UNREAD_COUNT !== undefined && data.UNREAD_COUNT !== null) {
          this.count = Number(data.UNREAD_COUNT);
        } else if (data.data && data.data.notViewCount !== undefined && data.data.notViewCount !== null) {
          this.count = Number(data.data.notViewCount);
        } else {
          this.count = unreadCount;
        }
        this.notifyLength = notifications.length;
        this.cd.detectChanges();
        /* if(notifications.length==0){
         this.ajaxNotificationsHeight = '115px';
          this.ajaxDropdownHeight = '115px';
        }
        else if(notifications.length==1){
         this.ajaxNotificationsHeight = '119px';
          this.ajaxDropdownHeight = '174px';
        }
        else if(notifications.length==2){
         this.ajaxNotificationsHeight = '222px';
          this.ajaxDropdownHeight = '277px';
        }
        else if(notifications.length==3){
         this.ajaxNotificationsHeight = '333px';
          this.ajaxDropdownHeight = '388px';
        }
        else{
         this.ajaxNotificationsHeight = '384px';
          this.ajaxDropdownHeight = '438px';
        } */

      } else {
        $('#apiErrorMessageActivitiesPopup').dialog("open");
      }
    });
  }

  private documentSub: any;
  onToggle() {
    let dropdown = $('.ajax-dropdown', this.el.nativeElement);
    this.active = !this.active;
    if (this.active) {
      // dropdown.fadeIn();
      dropdown
        .css('display', 'flex')   // force flex
        .hide()
        .fadeIn();
      this.getNotificationsList();
      this.bindDocumentClick();
    } else {
      dropdown.fadeOut(() => {
        dropdown.css('display', 'none');
      });
      this.documentUnsub();
    }

  }

  bindDocumentClick() {
    this.documentUnsub();
    this.documentSub = this.renderer.listen('document', 'click', (event: Event) => {
      if (!this.active) {
        return;
      }
      const target = event.target as Node;
      if (target && this.el.nativeElement.contains(target)) {
        return;
      }
      this.active = false;
      const dropdown = $('.ajax-dropdown', this.el.nativeElement);
      dropdown.fadeOut(() => {
        dropdown.css('display', 'none');
      });
      this.documentUnsub();
    });
  }



  update() {
    this.loading = true;
    this.getNotificationsList();
    setTimeout(() => {
      this.lastUpdate = new Date();
      this.loading = false;
    }, 1000);
  }

  private pendingReadIds = new Set<string>();

  onNotificationClick(item: any) {
    if (item && item.viewed === '0') {
      const id = item.taskId || item.detId || item.docId;
      if (id) {
        this.checkedNotification(String(id));
      }
    }
  }

  checkedNotification(id: string) {
    const strId = String(id);
    if (!strId || this.pendingReadIds.has(strId)) return;
    this.pendingReadIds.add(strId);

    // Optimistic UI update
    if (this.currentActivity && this.currentActivity.data) {
      const item = this.currentActivity.data.find(x => String(x.taskId) === strId || String(x.detId) === strId || String(x.docId) === strId);
      if (item && item.viewed === '0') {
        item.viewed = '1';
        item.status = 'read';
        this.count = Math.max(0, this.count - 1);
        this.cd.detectChanges();
      }
    }

    let fdata = new FormData();
    fdata.append('id', strId);
    fdata.append('companyId', localStorage.getEncryptedItem('companyId'));
    fdata.append('instanceId', localStorage.getEncryptedItem('instanceId'));
    fdata.append('loggedInTime', localStorage.getEncryptedItem('loggedInTime'));
    fdata.append('lastRequestTime', localStorage.getEncryptedItem('lastRequestTime'));
    fdata.append('userId', localStorage.getEncryptedItem('loginId'));
    fdata.append('language', this.commonService.getCurrentLanguageCode());

    const encrData = this.buildEncryptedFormData(fdata);

    this.activitiesService.updateApplicationEventReadStatus(encrData).subscribe(
      (res: any) => {
        this.pendingReadIds.delete(strId);
        if (res && (res.SUCCESS || res.status)) {
          if (res.RESPONSETIME) {
            localStorage.setEncryptedItem('lastRequestTime', res.RESPONSETIME);
          }
          this.getNotificationsList();
        }
      },
      () => {
        this.pendingReadIds.delete(strId);
      }
    );
  }


  ngOnDestroy() {
    this.documentUnsub();
    $('#apiErrorMessageActivitiesPopup').dialog("destroy");
    this.langChangeSubscription.unsubscribe();
    if (this.serviceRefreshSub) {
      this.serviceRefreshSub.unsubscribe();
    }
  }

  documentUnsub() {
    this.documentSub && this.documentSub();
    this.documentSub = null;
  }
  initApiErrorMessagePopup() {
    this.apiErrorMessageOptions = {
      autoOpen: false,
      modal: true,
      dialogClass: 'deletegroupmember',
      width: window.innerWidth > 767 ? 350 : '100%',
      resizable: false,
      closeText: '',
    };
    $("#apiErrorMessageActivitiesPopup").dialog(this.apiErrorMessageOptions);
  }
  closeApiErrorMessagePopup() {
    $('#apiErrorMessageActivitiesPopup').dialog("close");
  }

}
